import React from "react";
import { createGlobalStyle } from "styled-components";
var COMMON_ASSET_URL = "https://assets.reastatic.net/common/pangea-variable";
var fontFaceGlobalCss = "\n@font-face {\n  font-family: 'Pangea';\n  font-display: swap;\n  src: url('" + COMMON_ASSET_URL + ".woff2') format('woff2-variations'), url('" + COMMON_ASSET_URL + ".woff') format('woff-variations');\n  font-weight: 300 700;\n}\n\nbody {\n  font-family: 'Pangea', 'Helvetica Neue', Helvetica, Arial, sans-serif;\n  font-weight: 400;\n  font-variation-settings: \"XTDR\" 50, \"APRT\" 100, \"SPAC\" 40;\n}\n";
var pangeaTags = "<style>" + fontFaceGlobalCss + "</style>\n<link rel=\"preload\" href=\"" + COMMON_ASSET_URL + ".woff2\" as=\"font\" type=\"font/woff2\" crossOrigin=\"anonymous\" />";
var GlobalStyle = createGlobalStyle(["", ""], fontFaceGlobalCss);

// Note, technically these <link> tags are only supposed to be in the <head>,
// however browsers still seem to respect it if it's in the body.
// Also, this is only done for the `woff2` versions and any browser that
// doesn't support `woff2` won't support preloading either.
var PreloadLinks = () => /*#__PURE__*/React.createElement("link", {
  rel: "preload",
  href: COMMON_ASSET_URL + ".woff2",
  as: "font",
  type: "font/woff2",
  crossOrigin: "anonymous"
});

/**
 * Loads Pangea font from the CDN
 *
 * @see [Pangea documentation](https://construct-kit.reainternal.net/components/web/core/pangea)
 */
var Pangea = _ref => {
  var {
    renderPreloadLinks = true
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, renderPreloadLinks && /*#__PURE__*/React.createElement(PreloadLinks, null), /*#__PURE__*/React.createElement(GlobalStyle, null));
};
Pangea.displayName = "Pangea";
export { pangeaTags };
export default Pangea;